import React, { useEffect, useMemo, useState } from "react";

import { store } from "../../store/store";
import { getCampaignLeadLogTable } from "../../store/actions/campaignActions";
import { useAppSelector } from "../../store/hooks";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import {
  ICampaignLeadLogTableType,
  ILeadDispositionLog,
} from "../../types/campaignTypes";
import { Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight, MoreHorizontal } from "lucide-react";
import ReactPaginate from "react-paginate";
import { pageSizes } from "../../utils/utils";
import { ITablePagination } from "../../types/commonTypes";
import moment from "moment";
export default function CampaignLeadLogsTab() {
  const leadData = useAppSelector((state) => state?.campaign.lead);
  const leadLogData = useAppSelector((state) => state?.campaign.leadLogTable);
  const [paginationMetaData, setPaginationMetaData] = useState({
    take: pageSizes[0].value,
    skip: 0,
  });

  useEffect(() => {
    getData({
      pageData: paginationMetaData,
      data: { leadId: leadData.leadId },
    });
  }, [paginationMetaData, leadData]);

  const handlePageClick = (data: any) => {
    const skip = data.selected * paginationMetaData.take;
    const newPagination: ITablePagination = {
      ...paginationMetaData,
      skip,
    };
    setPaginationMetaData(newPagination);
  };
  const getData = (data: ICampaignLeadLogTableType) => {
    console.log("first");
    store.dispatch(getCampaignLeadLogTable(data));
  };
  const data = useMemo(() => leadLogData.data, [leadLogData]);
  const columns = useMemo<ColumnDef<ILeadDispositionLog>[]>(
    () => [
      {
        accessorKey: "disposition.name",
        header: "Disposition",
      },
      {
        accessorKey: "subDisposition.name",
        header: "Sub Disposition",
      },

      {
        accessorKey: "createdAt",
        cell: (info) => moment(info.row.original.createdAt).format("lll"),
        header: "Created At",
      },

      {
        accessorKey: "remarks",
        cell: (info) => (
          <div className="flex justify-center gap-1 items-end ">
            {info.row.original?.notes &&
              info.row.original?.notes?.substring(0, 16)}{" "}
            {info.row.original?.notes?.length > 16 && (
              <Tooltip
                title={info.row.original.notes}
                className="cursor-pointer"
              >
                <MoreHorizontal size={15} />
              </Tooltip>
            )}
          </div>
        ),
        header: "Remarks",
      },
    ],
    [leadLogData]
  );
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // getFilteredRowModel: getFilteredRowModel(),
    // getPaginationRowModel: getPaginationRowModel(),
    debugTable: false,
    manualPagination: true,
    // pageCount: customerListPageCount
    //   ? Math.ceil(customerListPageCount / pageSize)
    //   : undefined,
    // state: {
    //   pagination,
    // },
    // onPaginationChange: setPagination,
  });
  return (
    <div className="overflow-y-auto">
      {/* <span className="page-title">Campaign Lead List</span> */}
      <section className="bg-white pb-4">
        <div className="table-wrapper">
          <table className="p-2 w-full ">
            <thead className="w-full bg-primary table-head-sticky">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="">
                  {headerGroup.headers.map((header) => (
                    <th key={header.id} className="tb-head">
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header?.toString(),
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="">
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="tb-row">
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="tb-data  ">
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-2 gap-3">
          <ReactPaginate
            previousClassName="pagination-pre-btn"
            nextClassName="pagination-next-btn"
            previousLabel={<ChevronLeft size={20} className=" text-black" />}
            nextLabel={<ChevronRight size={20} className=" text-black" />}
            breakLabel="..."
            breakClassName={"break-me"}
            pageCount={
              leadLogData.paginationMetaData.count / paginationMetaData.take
            }
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            disabledClassName=""
            activeClassName="pagination-active-btn"
            pageClassName="pagination-inactive-btn"
          />
          <select
            className="p-2"
            onChange={(e) => {
              const newPagination: ITablePagination = {
                ...paginationMetaData,
                take: Number(e.target.value),
              };
              setPaginationMetaData(newPagination);
            }}
          >
            {pageSizes.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </section>
    </div>
  );
}
